export function MapPhysics(groups, map) {
  const nodes = [];

  groups.forEach((g) => {
    const base = map.latLngToLayerPoint([g.city.lat, g.city.lon]);

    const items = [
      ...g.suppliers.map((x) => ({ type: "supplier", data: x })),
      ...g.warehouses.map((x) => ({ type: "warehouse", data: x })),
      ...g.orders.map((x) => ({ type: "order", data: x })),
    ];

    const radius = 130;

    items.forEach((n, i) => {
      const angle = (i / items.length) * Math.PI * 2;

      nodes.push({
        ...n,
        cityId: g.city.id,

        cx: base.x,
        cy: base.y,

        x: base.x + Math.cos(angle) * radius,
        y: base.y + Math.sin(angle) * radius,

        vx: 0,
        vy: 0,
      });
    });
  });

  const MIN_DIST = 140;

  for (let step = 0; step < 35; step++) {
    for (const n of nodes) {
      n.vx += (n.cx - n.x) * 0.02;
      n.vy += (n.cy - n.y) * 0.02;

      n.vx += Math.sin(step * 0.2 + n.cx) * 0.06;
      n.vy += Math.cos(step * 0.2 + n.cy) * 0.06;
    }

    for (let i = 0; i < nodes.length; i++) {
      for (let j = i + 1; j < nodes.length; j++) {
        const a = nodes[i];
        const b = nodes[j];

        if (a.cityId !== b.cityId) continue;

        const dx = b.x - a.x;
        const dy = b.y - a.y;
        const dist = Math.sqrt(dx * dx + dy * dy) || 1;

        if (dist < MIN_DIST) {
          const push = (MIN_DIST - dist) / dist;

          a.vx -= dx * push * 0.4;
          a.vy -= dy * push * 0.4;

          b.vx += dx * push * 0.4;
          b.vy += dy * push * 0.4;
        }
      }
    }

    for (const n of nodes) {
      n.x += n.vx;
      n.y += n.vy;

      n.vx *= 0.85;
      n.vy *= 0.85;
    }
  }

  return nodes;
}